import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {
  RQ_ADD_ATTENDANCE_API,
  RQ_ATTENDANCE_BY_FILTER_API,
  RQ_DELETE_ATTENDANCE_API,
  RQ_GET_ALL_ATTENDANCE_API,
  RQ_GET_ATTENDANCE_BY_EMPLOYEE_ID_API,
  RQ_GET_ATTENDANCE_BY_EMPLOYEE_NAME_API,
  RQ_UPDATE_ATTENDANCE_API,
} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetAllAttendanceAPI = (token, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_all_attendance'],
    queryFn: async () => {
      return (
        (await rqCreateRequest(
          RQ_GET_ALL_ATTENDANCE_API,
          null,
          token,
          null,
        )) || []
      );
    },
    enabled: !!token,
    ...options,
  });
};

export const RQGetAttendanceByEmployeeId = (employeeId, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_attendance_by_employee', employeeId],
    queryFn: async () => {
      return rqCreateRequest(
        RQ_GET_ATTENDANCE_BY_EMPLOYEE_ID_API,
        null,
        token,
        {employeeId},
      );
    },
    enabled: !!token && !!employeeId,
    ...options,
  });
};

export const RQAddAttendance = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_add_attendance'],
    mutationFn: async ({attendanceData, token}) => {
      return rqCreateRequest(
        RQ_ADD_ATTENDANCE_API,
        attendanceData,
        token,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['rq_get_all_attendance']});
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
  });
};

export const RQUpdateAttendance = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_update_attendance'],
    mutationFn: async ({id, attendanceData, token}) => {
      return rqCreateRequest(
        RQ_UPDATE_ATTENDANCE_API,
        attendanceData,
        token,
        {id},
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['rq_get_all_attendance']});
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
  });
};

export const RQDeleteAttendance = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_delete_attendance'],
    mutationFn: async ({id, token}) => {
      return rqCreateRequest(
        RQ_DELETE_ATTENDANCE_API,
        null,
        token,
        {id},
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['rq_get_all_attendance']});
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
  });
};

export const RQGetAttendanceByEmployeeName = (name, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_attendance_by_employee_name', name],
    queryFn: async () => {
      return rqCreateRequest(
        RQ_GET_ATTENDANCE_BY_EMPLOYEE_NAME_API,
        null,
        token,
        {name},
      );
    },
    enabled: !!token && !!name,
    ...options,
  });
};

export const RQGetAttendanceByFilter = (filterData, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_attendance_by_filter', filterData],
    queryFn: async () => {
      return rqCreateRequest(
        RQ_ATTENDANCE_BY_FILTER_API,  
        filterData,
        token,
      );
    },
    enabled: !!token && !!filterData,
    ...options,
  });
};
